/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const LAYOUT_MAP: {
	[key: string]: 'DoubleStack' | 'TripleStack' | 'Aside' | 'AsideExtended';
} = {
	HomePageLayout: 'DoubleStack',
};

export const SLOT_MAP: {
	[key: string]: string;
} = {
	first: '1',
	second: '2',
	third: '3',
	fourth: '4',
	fifth: '5',
	six:'6',
	seven:'7',
	eight:'8',
	nine:'9',
	ten:'10',
	eleven:'11',
	twelve:'12',
	thirteen:'13',
	fourteen:'14',
	fifteen:'15',
	sixteen:'16',
	seventeen:'17',
	eighteen:'18',
	nineteen:'19',
	twenty:'20',
	twentyone:'21',
	twentytwo:'22',
	twentythree:'23',
	twentyfour:'24',
	twentyfive:'25',
	twentysix:'26',
	twentyseven:'27',
	twentyeight:'28',
	twentynine:'29',
	thirty:'30',
	thirtyone:'31',
	thirtytwo:'32',
	thirtythree:'33',
	thirtyfour:'34',
	thirtyfive:'35',
	thirtysix:'36',
	thirtyseven:'37',
	thirtyeight:'38',
	thirtynine:'39',
	forty:'40',
	fortyone:'41',
	fortytwo:'42',
	fortythree:'43',
	fortyfour:'44',
	fortyfive:'45',
	fortysix:'46',
	fortyseven:'47',
	fortyeight:'48',
	fortynine:'49',
	fifty:'50',
	fiftyone:'51',
	fiftytwo:'52',
	fiftythree:'53',
	fiftyfour:'54',
	fiftyfive:'55',
	fiftysix:'56',
	fiftyseven:'57',
	fiftyeight:'58',
	fiftynine:'59',
	sixty:'60',
	sixtyone:'61',
	sixtytwo:'62',
	sixtythree:'63',
	sixtyfour:'64',
	sixtyfive:'65',
	sixtysix:'66',
	sixtyseven:'67',
	sixtyeight:'68',
	sixtynine:'69',
	seventy:'70',
	seventyone:'71',
	seventytwo:'72',
	seventythree:'73',
	seventyfour:'74',
	seventyfive:'75',
	seventysix:'76',
	seventyseven:'77',
	seventyeight:'78',
	seventynine:'79',
	eighty:'80',
	eightyone:'81',
	eightytwo:'82',
	eightythree:'83',
	eightyfour:'84',
	eightyfive:'85',
	eightysix:'86',
	eightyseven:'87',
	eightyeight:'88',
	eightynine:'89',
	ninety:'90',
	ninetyone:'91',
	ninetytwo:'92',
	ninetythree:'93',
	ninetyfour:'94',
	ninetyfive:'95',
	ninetysix:'96',
	ninetyseven:'97',
	ninetyeight:'98',
	ninetynine:'99',
	hundred:'100',
	hundredone:'101',
	hundredtwo:'102',
	hundredthree:'103',
	hundredfour:'104',
	hundredfive:'105',
	hundredsix:'106',
	hundredseven:'107',
	hundredeight:'108',
	hundrednine:'109',
	hundredten:'110',
	hundredeleven:'111',
	hundredtwelve:'112',
	hundredthirteen:'113',
	hundredfourteen:'114',
	hundredfifteen:'115',
};

export const PAGE_TOKEN_NAME_CATEGORY = 'CategoryToken';
export const PAGE_TOKEN_NAME_PRODUCT = 'ProductToken';
export const PAGE_TYPES = {
	ProductPage: 'ProductPage',
	B2BProductPage: 'B2BProductPage',
	ContentPage: 'ContentPage',
	ItemPage: 'ItemPage',
};




// Aurora layout mapping //
// List of Aurora widget, used to identify if layout is created in commerce composer
export const AURORA_WIDGETS_LIST = [
	'BreadcrumbTrail_801',
	'EMarketingSpot_801',
	'Heading_801',
	'CategoryNavigation_801',
	'CatalogEntryList_801',
	'TextEditor_801',
	'ContentRecommendation_801',
	'FacetNavigation_801',
	'CatalogEntryRecommendation_801'
];

export const  AURORA_RUBY_WIDGET_NAME_MAPPING: { [key: string]: string; } = {
	'EMarketingSpot_801': 'e-marketing-spot-widget',
	'ContentRecommendation_801': 'content-recommendation-widget',
	'TextEditor_801': 'content-recommendation-widget',
	'BreadcrumbTrail_801':'breadcrumb-trail-widget',
	'FacetNavigation_801':'facet-navigation-widget',
	'CatalogEntryList_801': 'catalog-entry-list-widget',
	'Heading_801':'heading-widget-rv',
	'CategoryNavigation_801':'category-navigation-widget-rv',
	'CatalogEntryRecommendation_801':'catalog-entry-recommendation-widget',
	'FlowboxDynamicProductContentWidget':'flowbox-plp-widget-rv',
	'FlowboxStaticContentWidget':'flowbox-contentpage-widget-rv',
	'ScrollUpWidget':'scroll-up-widget-rv'
};

export const HELLO_RETAIL_WIDGET_NAME_MAPPING: { [key: string]: string; } = {
	'facet-navigation-widget':'hello-retail-facet-navigation-widget',
	'facet-navigation-widget-rv':'hello-retail-facet-navigation-widget',
	'catalog-entry-list-widget': 'hello-retail-catalog-entry-list-widget',
	'category-navigation-widget': 'hello-retail-category-navigation-widget',
	'category-navigation-widget-rv': 'hello-retail-category-navigation-widget',
};

//list of page types for which,  ruby supports the commerce composer layout
export const RUBY_SUPPORTED_AURORA_PAGE_TYPES = [
	'ContentPage',
	'ProductListPage',
	'SearchPage',
	'CategoryPage'
]